/**
 * Cabeçalho das telas de drill-down (Task 10): diz de QUAL indicador os
 * registros vieram e oferece a volta ao dashboard. É o que torna o caminho
 * "indicador → registros" explícito para o operador, e não só uma rota.
 */
import { createElement as h, type ReactElement } from "react";
import { Link } from "react-router-dom";
import type { KpiId } from "../dashboard/kpis.js";

const KPI_LABELS: Record<KpiId, string> = {
  faturamento: "Faturamento",
  pedidos: "Pedidos",
  margem_estimada: "Margem estimada",
  pedidos_pendentes: "Pedidos pendentes",
  falhas_sincronizacao: "Falhas de sincronização",
  estoque_critico: "Estoque crítico",
  conversas_aguardando: "Conversas aguardando",
  garantias_abertas: "Garantias abertas",
  sla_atendimento: "SLA de atendimento"
};

export function kpiLabel(kpiId: KpiId): string {
  return KPI_LABELS[kpiId];
}

export interface DrillDownHeaderProps {
  title: string;
  kpiId: KpiId | null;
  recordCount: number;
  recordNoun: string;
}

export function DrillDownHeader({ title, kpiId, recordCount, recordNoun }: DrillDownHeaderProps): ReactElement {
  // Redesign admin: mesmo desenho do `PageHeader` (título grande, origem suave) e o
  // "Voltar" como botão de contorno à direita. `data-drilldown-origin`, o texto
  // exato e o Link to="/" são PRESERVADOS (os testes batem neles).
  return h(
    "header",
    { className: "drilldown-header flex flex-wrap items-end justify-between gap-3" },
    h(
      "div",
      { className: "min-w-0" },
      h("h2", { className: "text-2xl font-extrabold text-ink" }, title),
      h(
        "p",
        {
          className: "drilldown-header__origin mt-1 text-sm text-muted",
          "data-drilldown-origin": kpiId ?? "none"
        },
        kpiId
          ? `${recordCount} ${recordNoun} que compõem o indicador "${kpiLabel(kpiId)}".`
          : `${recordCount} ${recordNoun} no total.`
      )
    ),
    // O "voltar" só faz sentido quando a tela foi aberta a partir de um indicador.
    kpiId
      ? h(
      Link,
      {
        to: "/",
        className:
          "drilldown-header__back inline-flex min-h-[40px] items-center rounded-control border border-border-strong bg-surface px-3 text-sm font-semibold text-body hover:bg-surface-soft"
      },
      "Voltar ao dashboard executivo"
    )
      : null
  );
}
